// Project Summary Table Name For Filtering Visual
export const PROJECT_SUMMARY_TABLE = "ProjectPredictionSummaryChart";

// Limit size - How many Project cards to show
export const PROJECTS_LIMIT_SIZE = 1000;

// PBI Limitation for PBI Filter values
export const FILTER_VALUES_LIMIT = 30000;

// Delay for filtering Visual data
export const FILTER_APPLY_DELAY_MS = 1000;
